<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2020-07-27 14:43:57
 * @LastEditors: mrh
 * @LastEditTime: 2020-09-14 17:25:41
--> 

<template>
  <div class="notices">
    <goods-list :list-data="list">
      <!-- 作用域插槽，填充todolist组件的内容。 -->
      <template v-slot:countDowm="{ item }">
        <van-count-down
          :time="item.countDown*1000"
          v-show="item.countDown>0"
          format="DD天HH:mm:ss开始"
        />
      </template>
      <template v-slot:slotVal="{ item }">
        <div class="numbers" v-if='item.reservationNum>0'>
          <img src="../../assets/img/yy2.png" alt />

          <span>{{item.reservationNum}}</span>
        </div>
        <span class="nsellerName">{{item.sellerName}}</span>
        <span class="nshares">分享好友购买，0元获得同款商品</span>
        <p class='goodPrices'>
          <span class="prices">￥{{item.price}}</span>
          <span class="guides">￥{{item.guidePrice}}</span>
        </p>
      </template>
      <template v-slot:proGoods>
        <!-- <span class='proGoods'>更多商品上架中</span> -->
      </template>
    </goods-list>
  </div>
</template>
<script>
import { reservationList } from "@/api/join";
import goodsList from "@/components/list/list";
export default {
  components: {
    goodsList
  },
  data() {
    return {
      list: []
    };
  },
  mounted() {
    this.reservationList();
  },
  methods: {
    reservationList() {
      let obj = {
        token: "", //token id
        communityShopId: this.$store.getters.communityShopId, //店长id,如果是去我的店铺中的更多预约商品，这里传0，后台根据token去拿到用户的店铺信息
        page: {
          way: "0", // 0:不分页 1:分页
          index: "1", //请求页
          size: "100" //请求大小
        },
        flag: "1", //0超值爆款（只查询爆款商品,可买），1 预约专区（未预约的商品） 2.爆款预告(不可买)
        cateId: "0" //商品分类的2级分类id,0表示不过滤分类
      };
      reservationList(obj).then(res => {
        this.list = res.content.list;
      });
    }
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.notices {
  width: auto;
  padding: 10px;
  height: calc(100% - 44px);
  // height: 100%;
  overflow-y: auto;
  background: #f4f4f4;
  .nsellerName {
    color: #208fff !important;
    font-size: 12px;
    padding: 2px 0 5px;
  }
  .nshares {
    color: #999999;
    font-size: 12px;
  }
  .numbers {
    width: auto;
    height: 18px;
    display: flex;
    align-items: center;
    background: #feede5;
    border-radius: 0px 2px 9px 0px;
    position: absolute;
    top: 6px;
    left: 10px;
    img {
      width: 26px;
      height: 18px;
    }
    span:last-child {
      width: auto;
      padding: 0 2px;
      font-size: 10px;
      transform: scale(0.8);
      color: #ff1310;
    }
  }
  /deep/.glist{
    .van-image {
      width: 110px;
      height: 110px;
      margin-right: 5px;
    }
  }
}
</style>
